exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".new-consultant-add-to-buttons {\n  margin-right: 1em; }\n\n.create_consultant_button {\n  margin-left: 17em; }\n", ""]);

